<template>
  <vwc-button
    :id="id"
    :label="label"
    :disabled="disabled"
    :class="extraClass"
    :type="type"
    :layout="layout"
    :shape="shape"
    :dense="dense"
    :full-width="fullWidth"
    :trailing-icon="trailingIcon"
    :icon="icon"
    :connotation="connotation"
    @click="(ev) => onClick(ev)"
  >
    <template name="trailingIcon">
      <slot name="trailingIcon"></slot>
    </template>
  </vwc-button>
</template>

<script>
  import '@vonage/vwc-button';

  export default {
    name: 'CdButton',
    // See description at https://vivid.vonage.com/?path=/story/atoms-button--basic
    props: {
      id: {
        type: String,
        default: '',
      },
      label: {
        type: String,
        default: '',
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      extraClass: {
        type: String,
        default: '',
      },
      type: {
        type: String,
        default: '',
      },
      layout: {
        type: String,
        default: '',
      },
      shape: {
        type: String,
        default: 'rounded',
      },
      dense: {
        type: Boolean,
        default: false,
      },
      fullWidth: {
        type: Boolean,
        default: false,
      },
      trailingIcon: {
        type: Boolean,
        default: false,
      },
      icon: {
        type: String,
        default: null,
      },
      connotation: {
        type: String,
        default: 'primary',
      },
    },
    methods: {
      onClick(ev) {
          const vwcButton = ev.target;
          const mdcButton = vwcButton.shadowRoot.querySelector('button');
          const ripple = mdcButton.querySelector('.ripple');
          if (ripple) { // check if we have ripple effect on the button
            const finalDiv = ripple.shadowRoot.querySelector('div');
            setTimeout(() => finalDiv.classList.remove('mdc-ripple-upgraded--background-focused'), 100);
          }
        this.$emit('click');
      }
    },
  };
</script>